import ApiService from "@/core/services/api.service";
// action types
export const ACCOUNT_VALIDATE = "accountValidate";
export const ACCOUNT_CREATE = "accountCreate";
// mutation types
export const SET_ERROR = "setError";

const state = {
  errors: {},
};

const actions = {
  [ACCOUNT_VALIDATE](context, account) {
    return new Promise(resolve => {
      ApiService.post({action:`/api/Cliente/v1/cliente/validar`}, account)
        .then(({ data }) => {
          console.log('retorna ' + data);
          resolve(data);
        })
        .catch(({ response }) => {
          console.log('error ' + response);
          context.commit(SET_ERROR, ["Datos proporcionados son incorrectos"] );//response.data.errors);
        });
    });
  },
  [ACCOUNT_CREATE](context, account) {
    return new Promise(resolve => {
      ApiService.post({action:`/api/Cliente/v1/cliente/registro/`}, account)
        .then(({ data }) => {
          console.log('retorna ' + data);
          resolve(data);
        })
        .catch(({ response }) => {
          console.log(response);
          context.commit(SET_ERROR, '');//response.data.errors);
        });
    });
  },
}
const mutations = {
  [SET_ERROR](state, error) {
    state.errors = error;
  }
};

export default {
  state,
  actions,
  mutations
};
